/**
 * Collection of assets
 * 
 * @class Collection_Assets
 */

Collection_Assets = ( function( BaseCollection ) {
	var Collection_Assets = function() {
		this.construct.apply( this, arguments );
	};

	$.extend( true, Collection_Assets.prototype, BaseCollection.prototype, {
		/**
		 * @inheriteddoc Collection#fetch
		 * @returns promise
		 */
		fetch: function( params ) {
			return new Promise(function(resolve, reject) {
				this.config.reqParams = ( params ? params.reqParams : this.config.reqParams ) || this.config.reqParams;
				this.reset();

				var section = this.config.reqParams.section,
					subsection = this.config.reqParams.subsection,
					progress = this.config.reqParams.progress,
					snippet = this.config.reqParams.snippet,
					genre = this.config.reqParams.genre;

				switch ( section ) {

					case 'home':
						if ( snippet === 'carousel' ) {
							this.parseData( App.catalogue.getSection( section ).getCarousel(), section, snippet );
							resolve();
						} else if ( snippet === 'smallcarousel' ) {
							if ( progress ) {
								API.fetchProgress()
									.bind( this )
									.then( function( data ) {
										this.parseProgress( data );
										resolve();
									}, function( err ) {
										console.warn( err );
										this.parseProgress( [] );  // ignore, handle as empty
										resolve();
									} )
									.catch( function( err ) {
										console.error( err );
										reject( err );
									} );
							} else {
								// one of rows in Home scene)
								this.parseData( this.config.reqParams.subsection, section, snippet );
								resolve();
							}
						}
						break;

					case 'kids':
						this.parseData( App.catalogue.getSection( section ).getItems(), section, snippet );
						resolve();
						break;

					case 'search':
						API.search( this.config.reqParams.query )
							.bind(this)
							.then( function( resp ) {
								if ( resp ) {
									// this.reset();
									this.parseSubsection( resp, section );
									resolve();
								} else {
									reject();
								}
							})
							.catch( function( err, status ) {
								App.throbberHide();
								App.notification( __( err ) );
								reject();
							});
						break;

					default:
						if ( genre.substr( 0, 3 ) === 'tv.' ) {
							genre = genre.slice( 3 );
							section = 'tv';
						} else if ( genre.substr( 0, 7 ) === 'movies.' ) {
							genre = genre.slice( 7 );
							section = 'movies';
						}
						API.fetchGenre( section, genre )
							.bind( this )
							.then( function( resp ) {
								if ( resp ) {
									this.parseSubsection( resp, section );
									resolve();
								} else {
									reject();
								}
							})
							.catch( function( err ) {
								App.throbberHide();
								App.notification( __( err ) );
								reject();
							});
						break;

				}

			}.bind( this ) )
		},

		/**
		 * @returns promise
		 */
		fetchRelated: function( params ) {
			App.throbber();
			return new Promise(function(resolve, reject) {
				this.config.reqParams = ( params ? params.reqParams : this.config.reqParams ) || this.config.reqParams;
				this.reset();

				API.fetchRelated( this.config.reqParams.section, this.config.reqParams.id )
					.bind(this)
					.then( function( resp ) {
						if ( resp && !resp.hasOwnProperty( 'errcode' ) && !resp.hasOwnProperty( 'error' ) ) {
							this.parseSubsection( resp );
							App.throbberHide();
							resolve();
						} else {
							App.throbberHide();
							reject();
						}
					})
					.catch( function( err, status ) {
						App.throbberHide();
						App.notification( __( err ) );
						reject();
					});

			}.bind(this))
		},

		/**
		 * parsing response to collection
		 * @param {Array of object} data
		 */
		parseData: function( data, scene, snippet ) {
			var items = ( data instanceof Array ) ? data : data.items || [], 
				item;

			for ( var i = 0; i < items.length; i++ ) {
				item = items[ i ];

				if ( snippet == 'carousel' ) {
					item.imagePackId_carousel = item.imagePackId;
					delete( item.imagePackId );
				} else if ( snippet == 'smallcarousel' ) {
					item.imagePackId_slider = item.imagePackId || item.imagePackId_slider;
					delete( item.imagePackId );
				}
				this.push( item );
				// added reference to the order
				this.models[ i ].data.relId = i;
			}
		},

		/**
		 * parsing response to collection
		 * @param {Array of object} data
		 */
		parseSubsection: function( data, section ) {
			var items = ( data instanceof Array ) ? data : data.items || [],
				item;

			for ( var i = 0; i < items.length; i++ ) {
				item = items[ i ];
				if ( !item ) {  // null occurred in some cases
					items.splice( i, 1 );
					--i;
					continue;
				}
				item.contentKey = item.contentKey || item.id;
				if ( section !== 'search' ) {
					item.contentType = section || item.contentType || item.categoryName;
				} else {
					item.contentType = item.contentType || item.categoryName;
				}

				this.push( item );
				// added reference to the order
				this.models[ i ].data.relId = i;
			}
		},

		/**
		 * parsing  /progress
		 * @param {Array of object} data
		 */
		parseProgress: function( data ) {
			var items = ( data instanceof Array ) ? data : [];
			for ( i in items ) {
				var item = {};
				item.contentType = ( items[ i ].category.id === '1251' || items[ i ].category.name === 'Movies' ) ? 'movies' : 'tv';
				item.imagePackId = items[ i ].metadata.imagePackId;
				if ( item.contentType  === 'tv' ) {
					item.contentKey = items[ i ].metadata.show.id;
					item.seasonNumber = items[ i ].metadata.seasonNumber;
					item.episodeNumber = items[ i ].metadata.episodeNumber;
					item.title = {
						'*': 'S' + ( item.seasonNumber < 10 ? '0' : '' ) + item.seasonNumber + 
						     'E' + ( item.episodeNumber < 10 ? '0' : '' ) + item.episodeNumber + ' ' +
						     Utils.getLocale( items[ i ].metadata.show.title )
					}
				} else {
					item.contentKey = items[ i ].assetId;
					item.title = {
						'*': Utils.getLocale( items[ i ].metadata.title )
					}
				}
				item.position = items[ i ].progress.position;
				item.totalTime = items[ i ].totalTime;

				this.push( item );
				// added reference to the order
				this.models[ i ].data.relId = i;
			}
		},

		/**
		 * To get Model specified by given id
		 * @param {String} id of asset
		 * @returns {Model} 
		 */
		getById: function( id ) {
			for ( var i = 0; i < this.models.length; i++ ) {
				if ( this.models[ i ].getID() == id ) {
					return this.models[ i ];
				}
			}
			return false;
		}

	} );

	return Collection_Assets;
} )( BaseCollection );



//////////////////
// WEBPACK FOOTER
// ./js/collection/collection_assets.js
// module id = 5
// module chunks = 0